import React from 'react';
import PropTypes from 'prop-types';

import {Box, List, Typography} from 'views/components';

import {Translate} from 'views/module';

import Backend from 'utils/backend';
import moment from 'moment';

import SlipView from './SlipView';

const ClientPaymentStatusData = ({statusProgressWrap}) => {
  const [completionList, setCompletionList] = React.useState([]);

  // Calculate the week starting from Monday (ISO Week)
  const weekStart = moment().subtract(1, 'week').startOf('isoWeek');
  const weekEnd = moment().subtract(1, 'week').endOf('isoWeek');
  const weekOf = weekStart.format('YYYY[Week]WW');

  React.useEffect(() => {
    statusProgressWrap(async () => {
      const result = await Backend.paymentSlip.queryCompletionClient(weekOf);
      const completionData = {...result.completionStatus};
      // Remove extraneous metadata properties
      delete completionData.weekOf;
      delete completionData.updatedAt;
      delete completionData.createdAt;
      const list = Object.values(completionData)
          .filter((item) => !item.client.name.toLowerCase().includes('test'))
          .sort((a, b) => {
            if (a.status === b.status) return 0;
            return a.status === 'IN_PROGRESS' ? -1 : 1;
          });
      setCompletionList(list);
    });
  }, [statusProgressWrap, weekOf]);

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Typography variant="subtitle1" align="center" gutterBottom>
        <Translate
          expression='dashboardWidgets.ClientPaymentStatus.WeekOf'
          substitute={{weekStart: weekStart.format('MMM DD'), weekEnd: weekEnd.format('MMM DD')}}
        />
      </Typography>
      <List>

        {
          completionList.map((item, index) => {
            return (
              <SlipView
                key={index}
                item={item}
                weekOf={weekOf}
                statusProgressWrap={statusProgressWrap}
              />
            );
          })
        }
      </List>
    </Box>
  );
};

ClientPaymentStatusData.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(ClientPaymentStatusData);
